/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type GlobalMessageTemplateIndexResource = {
    /**
     * Transform the resource into an array.
     */
    id: number
    name: string
    subject: string
    type: GlobalMessageTemplateIndexResource.type
    /**
     * Only returned with unlayer templates
     */
    thumbnail?: string
}

export namespace GlobalMessageTemplateIndexResource {
    export enum type {
        SMS = 'sms',
        UNLAYER = 'unlayer',
        HTML = 'html',
        TEXT = 'text'
    }
}
